import * as React from 'react';

import Alert16 from './Alert16';

export const alert16 = () => <Alert16 />;

export default {
    title: 'Icon|Fill|Alert16',
    component: Alert16,
    parameters: {
        notes: "`import Alert16 from 'box-ui-elements/es/icon/fill/Alert16';`",
    },
};
